module.exports = __webpack_public_path__ + "img/intro-title-en.e3b7abd5.gif";